export class FactorAnalysis {
  public creation_date: Date;
  public inception_date: Date;
  public last_date: Date;

  public contribution: any;
  public exposure: any;
  public sensitivity: any;
  public stability: any;
  public diversification: any;
  public rankings: any;
  public distance: any;
  public rebalancing: any;

  constructor() {}

  // initialize current portfolio from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.creation_date   = data.creation_date ? new Date(data.creation_date) : this.creation_date;
    this.inception_date  = data.inception_date ? new Date(data.inception_date) : this.inception_date;
    this.last_date       = data.last_date ? new Date(data.last_date) : this.last_date;

    this.exposure        = data.exposure ? data.exposure : this.exposure;
    this.sensitivity     = data.sensitivity ? data.sensitivity : this.sensitivity;
    this.stability       = data.stability ? data.stability : this.stability;
    this.contribution    = data.contribution ? data.contribution : this.contribution;
    this.diversification = data.diversification ? data.diversification : this.diversification;
    this.rankings        = data.rankings ? data.rankings : this.rankings;
    this.distance        = data.distance ? data.distance : this.distance;
    this.rebalancing     = data.rebalancing ? data.rebalancing : this.rebalancing;

    // Reverse the exposure object for better data access
    if (this.exposure) {
      Object.keys(this.exposure).forEach(key => {
        if (this.exposure[key]) {
          Object.keys(this.exposure[key]).forEach(subKey => {
            if (!this.exposure[subKey]) {this.exposure[subKey] = {};}
            this.exposure[subKey][key] = this.exposure[key][subKey]
          });
        }
      });
    }

    // Reverse the sensitivity object for better data access
    if (this.sensitivity) {
      Object.keys(this.sensitivity).forEach(key => {
        if (this.sensitivity[key]) {
          Object.keys(this.sensitivity[key]).forEach(subKey => {
            if (!this.sensitivity[subKey]) {this.sensitivity[subKey] = {};}
            this.sensitivity[subKey][key] = this.sensitivity[key][subKey]
          });
        }
      });
    }

    // Reverse the stability object for better data access
    if (this.stability) {
      Object.keys(this.stability).forEach(key => {
        if (this.stability[key]) {
          Object.keys(this.stability[key]).forEach(subKey => {
            if (!this.stability[subKey]) {this.stability[subKey] = {};}
            this.stability[subKey][key] = this.stability[key][subKey]
          });
        }
      });
    }

    // Reverse the contribution object for better data access
    if (this.contribution) {
      Object.keys(this.contribution).forEach(key => {
        if (this.contribution[key]) {
          Object.keys(this.contribution[key]).forEach(subKey => {
            if (!this.contribution[subKey]) {this.contribution[subKey] = {};}
            this.contribution[subKey][key] = this.contribution[key][subKey]
          });
        }
      });
    }

    // Reverse the diversification object for better data access
    if (this.diversification) {
      Object.keys(this.diversification).forEach(key => {
        if (this.diversification[key]) {
          Object.keys(this.diversification[key]).forEach(subKey => {
            if (!this.diversification[subKey]) {this.diversification[subKey] = {};}
            this.diversification[subKey][key] = this.diversification[key][subKey]
          });
        }
      });
    }

    // Reverse the distance object for better data access
    if (this.distance) {
      Object.keys(this.distance).forEach(key => {
        if (this.distance[key]) {
          Object.keys(this.distance[key]).forEach(subKey => {
            if (!this.distance[subKey]) {this.distance[subKey] = {};}
            this.distance[subKey][key] = this.distance[key][subKey]
          });
        }
      });
    }
  }
}
